import React from 'react';

import { ClientsPanelHeader } from '../../../common/custom';
import CustomContainer from '../../../common/custom/CustomContainer';
import { NoShipmentsComponent } from '../components';
import AllShipments from '../components/allShipments';
import { useCancelShipments } from './useCancelShipments';
import { CANCELEDSHIPMENTS } from '../../../constants/columns';

const CancelShipments = () => {
  const { data } = useCancelShipments();

  if (data?.length === 0) {
    return (
      <NoShipmentsComponent noManualPayment={false}>
        <ClientsPanelHeader reportShipment />
      </NoShipmentsComponent>
    );
  }
  return (
    <CustomContainer>
      <ClientsPanelHeader reportShipment />
      <AllShipments
        data={data}
        title='Canceled Shipments'
        columns={CANCELEDSHIPMENTS}
      />
    </CustomContainer>
  );
};

export default CancelShipments;
